import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'biz-excel-connector-list',
  templateUrl: './connect-excel-list.component.html',
  styleUrls: ['./connect-excel-list.component.scss']
})
export class ExcelConnectorListComponent implements OnInit {

  public searchValue = '';

  @Input() connectors: IExcelConnector[];
  @Input() selectedConnector: IExcelConnector;
  @Input() isLoading: boolean;
  @Output() onSelectConnector : EventEmitter<IExcelConnector> = new EventEmitter<IExcelConnector>();

  constructor() { }

  ngOnInit() {
  }

  public selectConnector(connector: IExcelConnector) {
    this.onSelectConnector.emit(connector);
  }

}
